import type { ScreenFilter, ScreenQuery, ScreenSort } from '@/schemas/screener'

/**
 * Query key factory. A page keys on its whole query; a count and the every-page read key on the
 * filter alone (and the order, for the read the CSV keeps in table order), so paging or sorting
 * never refetches a count.
 */
export const screenerKeys = {
  all: ['screener'] as const,
  metrics: () => [...screenerKeys.all, 'metrics'] as const,
  sectors: () => [...screenerKeys.all, 'sectors'] as const,
  page: (query: ScreenQuery) => [...screenerKeys.all, 'page', query] as const,
  count: (filter: ScreenFilter) => [...screenerKeys.all, 'count', filter] as const,
  every: (filter: ScreenFilter, sort: ScreenSort | null) =>
    [...screenerKeys.all, 'every', filter, sort] as const,
}
